import {Constants} from "./Constants";
import {StringUtility} from "./StringUtility";

export let SubscriptionDataUtility = {
    getSubscriptionTotalDisplay: function (subscription) {
        let totalDisplay = StringUtility.stringNumberToDisplayCurrency('' + subscription.invoice_total)
        if (subscription.subscription_billing_period) {
            totalDisplay += `/${subscription.subscription_billing_period.ext_stripe_value}`
        }
        return totalDisplay;
    },

    getSubscriptionLinesDisplay: function (subscription, withoutOn) {
        let linesDisplay = '';
        if (subscription.subscription_invoice_lines.length > 0) {
            if (!withoutOn) {
                linesDisplay += ' on ';
            }
            let productNames = [];
            for (let i = 0; i < Math.min(3, subscription.subscription_invoice_lines.length); i++) {
                let subscriptionInvoiceLine = subscription.subscription_invoice_lines[i];
                if (subscriptionInvoiceLine.name) {
                    productNames.push(subscriptionInvoiceLine.name)
                } else {
                    productNames.push(subscriptionInvoiceLine.fp_service.name)
                }
            }
            linesDisplay += productNames.join(', ')
            if (subscription.subscription_invoice_lines.length > 3) {
                linesDisplay += ', etc.'
            }
        }
        return linesDisplay;
    },

    fpInvoiceToSubscriptionFormData: function (fpInvoice, invoiceLines) {
        return {
            ext_fp_invoice_id: fpInvoice.id,
            ext_fp_invoice_number: fpInvoice.invoicenumber,
            subscription_description: fpInvoice.description || '',
            invoiceLines: invoiceLines.map(function (invoiceLine) {
                invoiceLine.invoice_line_type_id = Constants.qboInvoiceLineTypes.fpService
                return invoiceLine
            })
        }
    }
}
